import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    phone: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear errors when user starts typing
    if (error) setError('');
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setErrors({});

    try {
      const result = await register(formData);
      
      if (result.success) {
        navigate('/');
      } else {
        if (result.errors) {
          setErrors(result.errors);
        } else {
          setError(result.message || 'Registration failed');
        }
      }
    } catch (error) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Registration error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'clamp(10px, 3vw, 20px)'
    }}>
      <div style={{
        maxWidth: '450px',
        width: '100%',
        padding: 'clamp(30px, 8vw, 40px)',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h1 style={{
          fontSize: 'clamp(1.8rem, 5vw, 2.2rem)',
          fontWeight: 'bold',
          color: '#333',
          textAlign: 'center',
          marginBottom: 'clamp(20px, 5vw, 30px)'
        }}>
          Register
        </h1>

        {error && (
          <div style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: 'clamp(10px, 3vw, 15px)',
            borderRadius: '8px',
            marginBottom: 'clamp(15px, 3vw, 20px)',
            fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
            border: '1px solid #f5c6cb',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span style={{ fontSize: '1.2rem' }}>⚠️</span>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 'clamp(15px, 3vw, 20px)' }}>
            <label style={{
              display: 'block',
              marginBottom: 'clamp(5px, 1vw, 8px)',
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              fontWeight: '600',
              color: '#333'
            }}>
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'clamp(10px, 3vw, 12px)',
                border: errors.name ? '1px solid #dc3545' : '1px solid #ddd',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s ease'
              }}
            />
            {errors.name && (
              <div style={{
                color: '#dc3545',
                fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                marginTop: '4px'
              }}>
                {errors.name[0]}
              </div>
            )}
          </div>

          <div style={{ marginBottom: 'clamp(15px, 3vw, 20px)' }}>
            <label style={{
              display: 'block',
              marginBottom: 'clamp(5px, 1vw, 8px)',
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              fontWeight: '600',
              color: '#333'
            }}>
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'clamp(10px, 3vw, 12px)',
                border: errors.email ? '1px solid #dc3545' : '1px solid #ddd',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s ease'
              }}
            />
            {errors.email && (
              <div style={{
                color: '#dc3545',
                fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                marginTop: '4px'
              }}>
                {errors.email[0]}
              </div>
            )}
          </div>

          <div style={{ marginBottom: 'clamp(15px, 3vw, 20px)' }}>
            <label style={{
              display: 'block',
              marginBottom: 'clamp(5px, 1vw, 8px)',
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              fontWeight: '600',
              color: '#333'
            }}>
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'clamp(10px, 3vw, 12px)',
                border: errors.password ? '1px solid #dc3545' : '1px solid #ddd',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s ease'
              }}
            />
            {errors.password && (
              <div style={{
                color: '#dc3545',
                fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                marginTop: '4px'
              }}>
                {errors.password[0]}
              </div>
            )}
          </div>

          <div style={{ marginBottom: 'clamp(15px, 3vw, 20px)' }}>
            <label style={{
              display: 'block',
              marginBottom: 'clamp(5px, 1vw, 8px)',
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              fontWeight: '600',
              color: '#333'
            }}>
              Confirm Password
            </label>
            <input
              type="password"
              name="password_confirmation"
              value={formData.password_confirmation}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'clamp(10px, 3vw, 12px)',
                border: errors.password_confirmation ? '1px solid #dc3545' : '1px solid #ddd',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s ease'
              }}
            />
            {errors.password_confirmation && (
              <div style={{
                color: '#dc3545',
                fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                marginTop: '4px'
              }}>
                {errors.password_confirmation[0]}
              </div>
            )}
          </div>

          <div style={{ marginBottom: 'clamp(20px, 4vw, 30px)' }}>
            <label style={{
              display: 'block',
              marginBottom: 'clamp(5px, 1vw, 8px)',
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              fontWeight: '600',
              color: '#333'
            }}>
              Phone
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'clamp(10px, 3vw, 12px)',
                border: errors.phone ? '1px solid #dc3545' : '1px solid #ddd',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s ease'
              }}
            />
            {errors.phone && (
              <div style={{
                color: '#dc3545',
                fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                marginTop: '4px'
              }}>
                {errors.phone[0]}
              </div>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 'clamp(12px, 3vw, 15px)',
              backgroundColor: loading ? '#6c757d' : '#EDB404',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: 'clamp(1rem, 3vw, 1.1rem)',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              opacity: loading ? 0.7 : 1
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#d4a017';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#EDB404';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {loading ? 'Registering...' : 'Register'}
          </button>
        </form>

        <p style={{
          textAlign: 'center',
          marginTop: 'clamp(20px, 4vw, 30px)',
          fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
          color: '#666'
        }}>
          Already have an account?{' '}
          <Link
            to="/login"
            style={{
              color: '#EDB404',
              textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
